import './src/vaadin-checkbox-group.js';
export * from './src/vaadin-checkbox-group.js';
